module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "bar",
    style: ({
      width: _vm.value + '%'
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4611efa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 19
// module chunks = 0